import comp from "./AIDetailedPromptModal";
export default comp;
